import {
  Tabs as MuiTabs,
  Tab as MuiTab,
  TabsProps as MuiTabsProps,
  TabProps as MuiTabProps,
  styled,
} from '@mui/material';
import { colors } from '@themes/colors';
import { breakpoints } from '@themes/theme.helpers';

// STYLES
//--------
const StyledTabs = styled(MuiTabs)`
  background: #fff;
  margin: 16px 0;
  border-radius: 4px;
  ${breakpoints.up('md')} {
    margin: 40px 0;
  }
  .MuiTabs-indicator {
    height: 48px;
    opacity: 0.3;
  }
`;

const StyledTab = styled(MuiTab)`
  font-weight: 700;
  ${breakpoints.down('md')} {
    text-transform: none;
    font-size: 12px;
    padding-left: 10px;
    padding-right: 10px;
  }
  ${breakpoints.up('md')} {
    padding-left: 48px;
    padding-right: 48px;
  }
  &.Mui-selected {
    font-weight: 700;
    background: ${colors.primary.mainGreen};
    color: ${colors.text.primary};
  }
`;

// COMPONENTS
// Tab list wrapper

export type TabsProps = MuiTabsProps & {};

export const Tabs = (props: TabsProps) => {
  return <StyledTabs {...props} className='tabs'></StyledTabs>;
};

// Single Tab Item
export type TabProps = MuiTabProps & {};

export const Tab = (props: TabProps) => {
  return <StyledTab {...props}></StyledTab>;
};
